var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95043 3.35254C6.17301 4.00403 4.00437 6.17267 3.35288 8.95009C2.88237 10.9559 2.88237 13.0434 3.35288 15.0492C4.00437 17.8267 6.17301 19.9953 8.95044 20.6468C10.9563 21.1173 13.0437 21.1173 15.0496 20.6468C17.827 19.9953 19.9956 17.8267 20.6471 15.0492C21.1176 13.0434 21.1176 10.9559 20.6471 8.9501C19.9956 6.17267 17.827 4.00403 15.0496 3.35254",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05485 12C9.05485 12.5523 8.59486 13 8.02742 13C7.45999 13 7 12.5523 7 12C7 11.4477 7.45999 11 8.02742 11C8.59486 11 9.05485 11.4477 9.05485 12Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0274 12C13.0274 12.5523 12.5674 13 12 13C11.4326 13 10.9726 12.5523 10.9726 12C10.9726 11.4477 11.4326 11 12 11C12.5674 11 13.0274 11.4477 13.0274 12Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17 12.5523 16.54 13 15.9726 13C15.4051 13 14.9452 12.5523 14.9452 12C14.9452 11.4477 15.4051 11 15.9726 11C16.54 11 17 11.4477 17 12Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14617 6.6856L10.1294 2.55664",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00006 1.57286L10.129 2.55609",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/InProgressIcon.706110d5.svg";
export { ForwardRef as ReactComponent };